export default __webpack_public_path__ + "static/media/honeycomb.e273f4d4.webp";